import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';

import * as RestService from '../../services/eisRest';





  const DepartmentModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = React.useState(false);
    const [department, setDepartment] = React.useState([]);   
    const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
    const dialogRef = React.createRef();
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {      
      RestService.callAnyApi('company/getDepartment?id='+props.selectedRecord, null)
      .then((data) => {
           setDepartment(data);})
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=department&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
         
    }

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      
      department.name=values.name;
      department.departmentNo=values.departmentNo;
      department.description=values.description;
      

      RestService.callAnyApi(url, department)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        name: department.name || "",
        departmentNo: department.departmentNo || "",
        description: department.description || ""
      },
      validationSchema: Yup.object({
        name: Yup.string()     
          .required(t('general.message.required')),
        departmentNo: Yup.string()     
          .required(t('general.message.required'))
      }),
      onSubmit: (values) => {           
          save('company/saveDepartment',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('department.label.department')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                          <div class="col-12">
                              <div class="form-group">
                                <label>{t('general.label.name')}</label>
                                <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('name')} />
                              </div>
                              {formik.touched.name && formik.errors.name ? (
                                <div  style={{ color: 'red' }}>{formik.errors.name}</div>
                            ) : null} 
                            </div>                        
                            <div class="col-12">
                              <div class="form-group">
                                <label>{t('department.label.no')}</label>
                                <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('departmentNo')} />
                              </div>
                              {formik.touched.departmentNo && formik.errors.departmentNo ? (
                                <div  style={{ color: 'red' }}>{formik.errors.departmentNo}</div>
                            ) : null} 
                            </div>     
                            <div class="col-12">
                              <div class="form-group">
                                <label>{t('general.label.description')}</label>
                                <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('description')} />
                              </div>
                              {formik.touched.description && formik.errors.description ? (
                                <div  style={{ color: 'red' }}>{formik.errors.description}</div>
                            ) : null} 
                            </div>     
                          
                    </Modal.Body>
                    <Modal.Footer>     
                        
                       
                          <Button style={props.selectedRecord!='' ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>                             
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default DepartmentModal;